{
  "it": {
    "ai": {
      "settings": {
        "title": "Impostazioni AI",
        "description": "Configurazione delle funzionalità AI nel Suo spazio di lavoro.",
        "budget": {
          "title": "Budget mensile",
          "description": "Limite di spesa mensile per l'utilizzo dell'AI (fase di test). Ricalcolato in base all'utilizzo dei token in tutte le conversazioni di questo mese.",
          "budget_label": "Budget",
          "usage_label": "Utilizzato questo mese",
          "save": "Salva"
        }
      },
      "assistant": {
        "name": "Ziggy",
        "all_projects": "Tutti i progetti",
        "empty_state": {
          "title": "Come posso aiutarLa?",
          "subtitle": "Mi chieda qualsiasi cosa sui Suoi clienti"
        },
        "suggestions": {
          "open_decisions": "Quali decisioni sono ancora aperte?",
          "unassigned_units": "Quali unità non hanno ancora un cliente?",
          "help_notifications": "Come configuro le notifiche?",
          "help_project_settings": "Dove trovo le impostazioni del progetto?"
        },
        "input": {
          "placeholder": "Chieda dei Suoi clienti…",
          "hint": "Invio per inviare · Maiusc+Invio per andare a capo",
          "disclaimer": "I risultati potrebbero non essere accurati. Verifichi sempre le informazioni importanti."
        },
        "errors": {
          "generic": "Qualcosa è andato storto. Riprovi.",
          "budget_reached": "Il budget AI mensile per questo spazio di lavoro è stato raggiunto. Contatti un amministratore per aumentare il limite."
        },
        "cap": {
          "message": "Ha raggiunto il limite di conversazioni.",
          "action": "Avvia una nuova conversazione"
        },
        "history": {
          "title": "Conversazioni precedenti",
          "empty": "Nessuna conversazione precedente"
        },
        "support_cta": {
          "prompt": "Non è la risposta che cercava?",
          "action": "Contatta il supporto"
        }
      }
    }
  }
}
